import { OrganizationMarketplace } from '@spike/marketplace-model';
import { useMemo } from 'react';
import useOrganizationMarketplaces from './useOrganizationMarketplaces';
import { isSettingEnabled } from 'utils/SettingsUtils';

export type OrganizationServiceCategory =
    | 'boarding'
    | 'daycare'
    | 'training'
    | 'transportation'
    | 'walking'
    | 'grooming'
    | 'evaluation';

const SERVICE_CATEGORY_SETTING_KEY: Record<Exclude<OrganizationServiceCategory, 'evaluation'>, string> = {
    boarding: 'boarding_enabled',
    daycare: 'daycare_enabled',
    training: 'training_enabled',
    transportation: 'transportation_enabled',
    walking: 'walking_enabled',
    grooming: 'grooming_enabled'
};

export const isServiceCategoryEnabled = (
    marketplace: OrganizationMarketplace,
    category: OrganizationServiceCategory
): boolean => {
    if (category === 'evaluation') {
        return marketplace.evaluationEnabled || isSettingEnabled(marketplace.settings, 'evaluation_enabled');
    }

    const settingKey = SERVICE_CATEGORY_SETTING_KEY[category];
    return isSettingEnabled(marketplace.settings, settingKey);
};

export const useOrganizationMarketplacesByServiceCategory = (
    category: OrganizationServiceCategory
): Array<OrganizationMarketplace> => {
    const { organizationMarketplaces } = useOrganizationMarketplaces();

    return useMemo(
        () => organizationMarketplaces.filter(marketplace => isServiceCategoryEnabled(marketplace, category)),
        [organizationMarketplaces, category]
    );
};

export default useOrganizationMarketplacesByServiceCategory;
